module.exports = __webpack_public_path__ + "img/icons BFr_22.bec971e7.svg";